import { render, staticRenderFns } from "./widget-event-detail-test.vue?vue&type=template&id=869869d6"
import script from "./widget-event-detail-test.vue?vue&type=script&lang=ts"
export * from "./widget-event-detail-test.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports